import React, { useRef, useState } from "react";
import { photoUrl, uploadPhoto } from "../../../api/minisite";

export default function PhotoUploader({ clientId, slot, currentFilename, onChange }) {
  const fileInputRef = useRef();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    setError(null);
    try {
      const r = await uploadPhoto(clientId, file, slot);
      onChange(r.filename);
    } catch (err) {
      setError(err?.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ border: "1px dashed #ccc", padding: 16, borderRadius: 8 }}>
      {currentFilename && (
        <img
          src={photoUrl(clientId, currentFilename)}
          alt={slot}
          style={{ maxWidth: 200, maxHeight: 200, display: "block", marginBottom: 8 }}
        />
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleFile}
        style={{ display: "none" }}
      />
      <button onClick={() => fileInputRef.current?.click()} disabled={busy}>
        {busy ? "Upload..." : currentFilename ? "Changer la photo" : "Choisir une photo"}
      </button>
      {error && <div style={{ color: "red", fontSize: 12 }}>{error}</div>}
    </div>
  );
}
